import { priceTagConstants } from "../constants/priceTagConstants";

export interface PriceTag {
  id: number;
  name: string;
}
export interface PriceTagsAction {
  type: string;
  payload: {
    priceTags: PriceTag[];
  };
}

const initialState = {
  priceTags: [],
};

export default function priceTags(state = initialState, action: PriceTagsAction) {
  switch (action.type) {
    case priceTagConstants.SET_PRICE_TAGS:
      return {
        ...state,
        priceTags: action.payload.priceTags,
      };
    default:
      return state;
  }
}
